<template>
  <div
    class="items-column"
    :title="
      !isEditable &&
        'Please set Final Price, Exchange Rate and Price in local currency in order to be able to create Subscription period items'
    "
    @click="isEditable && params.onClick(params.data)"
  >
    <span :class="{ 'editable-cell': isEditable }">{{ params.data.items_count }}</span>
  </div>
</template>

<script>
// Libraries
import Vue from 'vue'

export default Vue.extend({
  computed: {
    isEditable() {
      const data = this.params.data

      return data.normalized_price !== null && data.exchange_rate !== null && data.price !== null
    }
  }
})
</script>

<style lang="scss" scoped>
.items-column {
  cursor: pointer;
}

.editable-cell {
  padding-bottom: 5px;
  border-bottom: 1px dashed var(--r-secondary-1);
}
</style>
